var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"main-container",staticStyle:{"padding":"0px 0px 0px 0px !important"},attrs:{"justify":"left"}},[_c('Nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }